import { render } from "./ActivityData.vue?vue&type=template&id=ddbe5e8c&scoped=true"
import script from "./ActivityData.ts?vue&type=script&lang=js"
export * from "./ActivityData.ts?vue&type=script&lang=js"

import "./ActivityData.vue?vue&type=style&index=0&id=ddbe5e8c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbe5e8c"]])

export default __exports__